import { registerPlugin } from '@capacitor/core';

/**
 * Read-only diagnostics for the offline asset store (see OfflineStoragePlugin.swift).
 *
 * The one fact JavaScript cannot learn through @capacitor/filesystem is
 * whether a path carries the `isExcludedFromBackup` flag. The store lives in
 * Library/NoCloud so that audio the user never asked for stays out of their
 * iCloud backup, and the code that sets the flag swallows its own failure,
 * so the flag is checked on a device rather than assumed.
 *
 * On the web this resolves to a proxy whose methods reject; gate on
 * isNativeApp(). Intended for the dev-only storage card, not for product code.
 */
export interface OfflineStorageInspection {
  exists: boolean;
  isDirectory: boolean;
  /** Absent when the path does not exist or the flag could not be read. */
  isExcludedFromBackup?: boolean;
  /** Bytes of regular files at or under the path, as the disk sees them. */
  diskBytes?: number;
  fileCount?: number;
}

export interface OfflineStoragePlugin {
  /** `path` is a `file://` URI or an absolute path. */
  inspect(options: { path: string }): Promise<OfflineStorageInspection>;
}

export const OfflineStorage = registerPlugin<OfflineStoragePlugin>('OfflineStorage');
